import axios from "axios";
import { clearAllCookies, getCookie, redirectToLogin } from "./Utils";

export const axiosRequest = axios.create({
  baseURL: process.env.REACT_APP_BaseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json", // Changed from x-www-form-urlencoded
  },
});

let redirectToLoginState = false;
axiosRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (getCookie("firstName") && !redirectToLoginState) {
        redirectToLogin();
        redirectToLoginState = true;
      } else {
        redirectToLoginState = false;
      }
    }
    return Promise.reject(error);
  },
);
